import React from 'react';
import PropTypes from 'prop-types';

import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { ptBR } from 'date-fns/locale';

import { Container, StyledDatePicker } from './styles';

export default function SelectDate({
  currentDateZoned,
  handlePrevDay,
  handleNextDay,
  dateFormatted,
  handleDateChange,
  disabledNextDay = false,
}) {
  return (
    <Container>
      <button type="button" onClick={handlePrevDay}>
        <FiChevronLeft size={28} />
      </button>
      <StyledDatePicker
        dateFormat="d 'de' MMMM"
        selected={new Date(currentDateZoned)}
        locale={ptBR}
        // maxDate={new Date()}
        onChange={date => {
          handleDateChange(date);
        }}
        customInput={<button>{dateFormatted}</button>}
      />
      {/* <h4> {dateFormatted}</h4> */}
      <button type="button" onClick={handleNextDay} disabled={disabledNextDay}>
        <FiChevronRight size={28} />
      </button>
    </Container>
  );
}

// SelectDate.defaultProps = {
//   disabledNextDay: false,
// };

SelectDate.propTypes = {
  currentDateZoned: PropTypes.string.isRequired,
  dateFormatted: PropTypes.string.isRequired,
  handleNextDay: PropTypes.func.isRequired,
  handlePrevDay: PropTypes.func.isRequired,
  handleDateChange: PropTypes.func.isRequired,
  disabledNextDay: PropTypes.bool,
};
